import { BankSlipPaymentInfo } from './bank-slip-payment-info.json';

export class BoletoBillingChanged {
  valid: boolean;
  bankSlip: BankSlipPaymentInfo;
}
